import {css} from '@emotion/react';
import styled from '@emotion/styled';

import {Container} from '@/components/Collapsible/components/Container';

type Props = {
  hasFadeOut?: boolean;
};

export const ContainerWithFade = styled(Container)<Props>(
  ({hasFadeOut, theme}) => css`
    ${hasFadeOut &&
    css`
      position: relative;
      &[data-state='closed']::after {
        content: '';
        position: absolute;
        bottom: 30px;
        left: 0;
        right: 0;
        height: 44px;
        background-image: linear-gradient(
          180deg,
          rgba(255, 255, 255, 0.5) 0%,
          rgba(255, 255, 255, 0.5) 0.01%,
          rgba(255, 255, 255, 0.5) 52.6%,
          ${theme.colors.contentInversePrimary} 100%
        );
      }
    `}
  `
);
